import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FeatureProvider } from './contexts/FeatureContext'; 
import App from './App';
import './index.css';
import { clearLegacyWebAppCaches } from './utils/cacheRefresh';
import { registerPwaServiceWorker } from './utils/registerPwaServiceWorker';

clearLegacyWebAppCaches().finally(registerPwaServiceWorker);

const script = document.createElement("script");
script.src = "https://accounts.google.com/gsi/client";
script.async = true;
script.defer = true;
document.body.appendChild(script);
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <FeatureProvider>
        <App />
      </FeatureProvider>
    </AuthProvider>
  </BrowserRouter>
);
